module.exports = __webpack_public_path__ + "img/eraser-btn.a63742f2.svg";